<template lang="pug">
    <line-chart :chart-data="datacollection" mt-0></line-chart>
</template>

<script>
import LineChart from '../../../store/components/LineChart.js'

export default {
  data: () => ({
    datacollection: {},
  }),
  props:{
    objeto: Object
  },
  
    mounted () {
      let arreglo_saldo=Object.keys(this.objeto).map(item=>({...this.objeto[item]}))
      this.fillData(arreglo_saldo)
    },

    methods: {   
        fillData(arreglo_saldo) {
                let etiquetas = this.llenar_etiquetas(arreglo_saldo)
                let datos = this.llenar_datos(arreglo_saldo)
                this.datacollection = {
                labels: etiquetas,
                datasets: [
                    {
                      label: arreglo_saldo[0].descripcion,
                      backgroundColor: 'primary',
                      data: datos
                    }
                ]
                }
      },
      llenar_etiquetas (arreglo_saldo) {
        let arreglo = []
        arreglo_saldo.map(item=>arreglo.push(item.periodo))
        return arreglo
      },
      llenar_datos (arreglo_saldo) {
        let arreglo = []
        arreglo_saldo.map(item=>arreglo.push(item.saldo))
        return arreglo
      }
    },
    components: {
      LineChart
    },
  
  }
</script>
